import { Typography } from 'seagull';
import styles from "./PackageCard.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function PackageCard(_ref) {
  let {
    id,
    name,
    children,
    bottomArea,
    testId
  } = _ref;
  return /*#__PURE__*/_jsxs("li", {
    className: styles.packageCard,
    "data-testid": testId,
    "data-bundleid": id,
    children: [/*#__PURE__*/_jsx(Typography, {
      className: styles.packageName,
      variant: "h5",
      testId: testId + '-title',
      children: name
    }), /*#__PURE__*/_jsx("ul", {
      className: styles.sectionsList,
      children: children
    }), bottomArea]
  });
}